import React from 'react'
import { BrowserRouter as Router, Link, Route } from 'react-router-dom'
import { Button, Col, Grid, Nav, Navbar, NavItem, Row } from 'react-bootstrap'
import { IndexLinkContainer, LinkContainer } from 'react-router-bootstrap'
import { Text, withLocale } from 'react-localizer'

import GmBlockingThreshold from './components/GmBlockingThreshold/GmBlockingThreshold'
import LockThePlace from './components/LockThePlace/LockThePlace'

import logo from './img/logo.svg'
import email from './img/email.svg'

import './css/home.css'

const Home = () => (
  <Grid id={'home'}>
    <Row className="show-grid">
      <Col xs={12}>
        <h3>
          <Text>home.title</Text>
        </h3>
      </Col>
    </Row>
    <Row className="show-grid">
      <Col sm={6}>
        <Link to="/GmBlockingThreshold">
          <Button><Text>menu.gmBlockingThreshold</Text></Button>
        </Link><br/>
        <div className="presentation">
          <Text>home.describeGmBlockingThreshold</Text>
        </div>

      </Col>
      <Col sm={6}>
        <Link to="/lockThePlace"><Button><Text>menu.lockThePlace</Text></Button></Link><br/>
        <div className="presentation"><Text>home.describeLockThePlace</Text>
        </div>
      </Col>
    </Row>
  </Grid>
)

const Contact = () => (
  <Grid id={'home'}>
    <Row className="show-grid">
      <Col xs={12}>
        <h3>
          <Text>contact.title</Text>
        </h3>
      </Col>
    </Row>
    <Row className="show-grid">
      <Col sm={6} smOffset={3}>
        <div className="presentation">
          <Text>contact.content</Text>
        <a
          target={'_blank'}
          rel="noopener noreferrer"
          href={'mailto:idee@keiro.ovh?subject=Foe%20website&body=Salut%20Keiro%20!'}>
          idee@keiro.ovh
        </a>
      </div>
    </Col>
  </Row>
  <Row className="show-grid m-t-20">
    <Col sm={6} smOffset={3}>
      <div className="presentation">
        <Text>contact.curious</Text><br/>
      <a
        target={'_blank'}
        rel="noopener noreferrer"
        href={'https://keiro.dev/'}>
        <Text>contact.portfolioLink</Text>
      </a>
    </div>
  </Col>
  </Row>
</Grid>
)

const MenuGmBlockingThreshold = () => (
  <div>
    <GmBlockingThreshold/>
  </div>
)

const MenuLockThePlace = () => (
  <div>
    <LockThePlace/>
  </div>
)

const languagesAvailable = {
  fr: {
    text: '🇫🇷 Français',
    abbrev: 'fr'
  },
  en: {
    text: '🇺🇸 English',
    abbrev: 'en'
  }
}

// trigger language change
const ButtonLanguage = withLocale((props) => {

  const languageToUse = (props.locale.language === 'en') ? languagesAvailable.fr : languagesAvailable.en

  return (
    <li><a className={'button-language'} onClick={() => {
      props.locale.setLanguage(languageToUse.abbrev)
      sessionStorage.setItem('lang', languageToUse.abbrev)
    }}>
      {languageToUse.text}&nbsp;&nbsp;<i className="fa fa-refresh" aria-hidden="true"/></a>
    </li>
  )
})
/**
 * Get Language From Browser, default to 'en', if no lang set in SessionStorage yet
 * @param props
 * @return {null}
 * @constructor
 */
const LanguageFromBrowser = withLocale((props) => {
  if (!sessionStorage.getItem('lang')) {

    // get locale from browser as 'fr' instead of 'fr-FR'
    const browserLanguageShorten = ((navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en').slice(0, 2)
    const languageToSet = languagesAvailable[browserLanguageShorten].abbrev

    props.locale.setLanguage(languageToSet)
    sessionStorage.setItem('lang', languageToSet)
  }
  return null
})

const Menu = () => (
  <Router>
    <div>
      <LanguageFromBrowser/>
      <div id={'menu'}>
        <Navbar inverse collapseOnSelect>
          <Navbar.Header>
            <Navbar.Toggle/>
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav>
              <IndexLinkContainer to="/">
                <NavItem eventKey={1}><img src={logo} className="App-logo" alt="logo"/></NavItem>
              </IndexLinkContainer>
              <LinkContainer to="/GmBlockingThreshold">
                <NavItem eventKey={2}><Text>menu.gmBlockingThreshold</Text></NavItem>
              </LinkContainer>
              <LinkContainer to="/lockThePlace">
                <NavItem eventKey={3}><Text>menu.lockThePlace</Text></NavItem>
              </LinkContainer>
              <LinkContainer to="/contact">
                <NavItem eventKey={4}><img src={email} className="App-email" alt="logo"/></NavItem>
              </LinkContainer>
            </Nav>
            <Nav pullRight>
              {/*<NavItem eventKey={1}>*/}
              <ButtonLanguage/>
              {/*</NavItem>*/}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>

      <div>
        <Route exact path="/" component={Home}/>
      </div>

      <div>
        <Route path="/contact" component={Contact}/>
        <Route path="/GmBlockingThreshold" component={MenuGmBlockingThreshold}/>
        <Route path="/lockThePlace" component={MenuLockThePlace}/>
      </div>
    </div>
  </Router>
)

/*const Topic = ({match}) => (
  <div>
    <h3>{match.params.topicId}</h3>
  </div>
)

const Topics = ({match}) => (
  <div>
    <h2>Topics</h2>
    <ul>
      <li>
        <Link to={`${match.url}/rendering`}>
          Rendering with React
        </Link>
      </li>
      <li>
        <Link to={`${match.url}/components`}>
          Components
        </Link>
      </li>
      <li>
        <Link to={`${match.url}/props-v-state`}>
          Props v. State
        </Link>
      </li>
    </ul>

    <Route path={`${match.url}/:topicId`} component={Topic}/>
    <Route exact path={match.url} render={() => (
      <h3>Please select a topic.</h3>
    )}/>
  </div>
)*/
export default Menu



// WEBPACK FOOTER //
// ./src/Menu.js